import { CircularProgress } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { HeaderSpacer } from '../components/Header';
import AuthorHeroPage from '../components/AuthorHeroPage';
import { fetchAuthorById } from '../redux/features/authors/authorsSlice';
import { selectContext } from '../redux/features/context/contextSlice';
import StyledBackdrop from '../components/StyledBackdrop';
import Login from '../components/Login';

export default function AuthorUpdateView() {
  const { authorId } = useParams();

  const dispatch = useDispatch();
  const context = useSelector(selectContext);
  const { userInfo } = useSelector((state) => state.users);

  const loadAuthor = useCallback(
    () => dispatch(fetchAuthorById({ namespace: 'private', authorId })),
    [dispatch, authorId],
  );

  useEffect(() => {
    if (userInfo && authorId) loadAuthor();
  }, [loadAuthor, userInfo, authorId]);

  const author = context && context.author;
  const isAuthorLoaded = author && author.id === authorId && (author.privateData || author.publicData);

  return (
    <>
      <HeaderSpacer />
      { !userInfo && <Login />}
      { userInfo && !isAuthorLoaded && (
        <StyledBackdrop open={!isAuthorLoaded}>
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      )}
      { userInfo && isAuthorLoaded && (
        <AuthorHeroPage
          author={author}
          namespace="private"
          onRefetch={loadAuthor}
          startInEdit
        />
      )}
    </>
  );
}
